import React, { useState } from 'react';
import { compose, withState, defaultProps } from 'recompose';
import { hot } from 'react-hot-loader';
import { Modal, Header, Icon, Button } from 'semantic-ui-react';
import { Offline, Online } from 'op/components/offline';
import { withLocale } from 'op/components/locale';
import FormWarningModal from '../warning-modal/warning-modal.component'
import { connect } from 'react-redux';
import { selectSystemSettings } from '../../../../redux/reducers/system-settings/system-settings.selectors';
const FormSubmitModal = ({ locale, validation, openModal, setOpenModal, onSubmit, onSave, online, hasNoAnswers, overallStatus, isFormTypeStatus, systemSettings}) => {
    const [showKpiWarning, setShowKpiWarning] = useState(false);
    const [showTotalFailureWarning, setShowTotalFailureWarning] = useState(false);
    const [warningLocaleKey, setWarningLocaleKey] = React.useState('submit');

    const handleSubmitClick = () => {
        if (hasNoAnswers && overallStatus && isFormTypeStatus && systemSettings.isMaintAlertForFailKPI) {
            setWarningLocaleKey('warningKpi');
            setShowKpiWarning(true);
        } else if (!overallStatus && systemSettings.isMaintAlertForTotalFailure) {
            setWarningLocaleKey('warningTotalFailure');
            setShowTotalFailureWarning(true);
        } else {
            setOpenModal(true);
        }
    };

    return (
        <React.Fragment>
            <FormWarningModal
                open={showKpiWarning || showTotalFailureWarning}
                warningLocaleKey={warningLocaleKey}
                onProceed={() => {
                    if (showKpiWarning) {
                        setShowKpiWarning(false);
                    } else if (showTotalFailureWarning) {
                        setShowTotalFailureWarning(false);
                    }
                    setOpenModal(true);
                }}
                onCancel={() => {
                    if (showKpiWarning) {
                        setShowKpiWarning(false);
                    } else if (showTotalFailureWarning) {
                        setShowTotalFailureWarning(false);
                    }
                }}
            />
            <Modal
                trigger={
                    <Button
                        type='button'
                        primary
                        disabled={!validation.ok}
                        onClick={handleSubmitClick}
                    >
                        {locale.saveOrSend}
                    </Button>
                }
                open={openModal}
                onClose={() => setOpenModal(false)}
                basic
            >
                <Header icon='th list' content={locale.header} />
                <Modal.Content>
                    {online ? (locale.content.map((line, i) => <p key={i}>{line}</p>)) : locale.content[0]}
                </Modal.Content>
                <Modal.Actions>
                    <Button basic onClick={() => setOpenModal(false)} color='red' inverted floated='left'>
                        <Icon name='remove' /> {locale._system.cancel}
                    </Button>
                    <Online>
                        <Button 
                            onClick={() => {
                                onSave();
                                setOpenModal(false);
                            }} 
                            color='blue' 
                            inverted
                        >
                            <Icon name='checkmark' /> {locale._system.save}
                        </Button>
                        <Button
                            type='submit'
                            onClick={() => {
                                onSubmit();
                                setOpenModal(false);
                            }}
                            color='green' 
                            inverted
                        >
                            <Icon name='checkmark' /> {locale.send}
                        </Button>
                    </Online>
                    <Offline>
                        <Button 
                            onClick={() => {
                                onSave();
                                setOpenModal(false);
                            }}
                            color='blue' 
                            inverted
                        >
                            <Icon name='checkmark' /> {locale._system.save}
                        </Button>
                    </Offline>
                </Modal.Actions>
            </Modal>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    systemSettings: selectSystemSettings(state)
});

export default compose(
    connect(mapStateToProps),
    withLocale('forms.submit'),
    withState('openModal', 'setOpenModal', false),
    defaultProps({
        onSave: () => {
        },
        onSubmit: () => {
        },
    }),
    hot(module),
)(FormSubmitModal);
